/** Barrel-Export der Service-Schicht – einzige Importquelle für die UI. */
export { auth, authStore } from "./auth.service";
export type { OAuthProvider, AuthBackend } from "./auth.service";
export { subjectsService, isSonstigesSubject } from "./subjects.service";
export { topicsService } from "./topics.service";
export { holidaysService, findHoliday, nextSummerBreakEnd } from "./holidays.service";
export type { Holiday, HolidayKind } from "./holidays.service";
export { materialsService } from "./materials.service";
// buildTopicPdf/saveTopicPdf ABSICHTLICH NICHT hier: die Kette
// document/topicPdf -> filePipeline -> pdf-lib ist ~430 kB. Über diesen
// Barrel (von praktisch jeder eager geladenen Seite importiert) würde das im
// Startbundle landen. Nur DocumentPage.ts importiert direkt aus
// "./document/topicPdf" – dessen Route ist selbst per Lazy-Import
// registriert (siehe main.ts).
export { homeworkService } from "./homework.service";
export type { HomeworkInput } from "./homework.service";
export { testsService } from "./tests.service";
export type { TestInput } from "./tests.service";
export { notesService } from "./notes.service";
export { timetableService, defaultSettings } from "./timetable.service";
export { pbErrorMessage } from "@/lib/pocketbase";
